export const CACHE_RELEASE_NOTES = 'RELEASE_NOTES:CACHE';
